
App.controller('PrnActivateCtrl', ['$rootScope', '$scope', '$http', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading', 'mixPanelApi', 
    '$location', 'organizationService', 'ProfessionalService', 'UsersClientService', 'sessionService',
    function ($rootScope, $scope, $http, ngDialog, $timeout, $localStorage, $sessionStorage,
              $state, Api, toastr, authApi, $stateParams, $loading, mixPanelApi,
              $location, organizationService, ProfessionalService, UsersClientService, sessionService) {
            $scope.user = {};
            $scope.pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
            $scope.professions = ['Nurse', 'Allied Health'];
            $scope.userLicense = '';
            $scope.userSpecialties = '';
            $scope.pageLoading = true;
            
            this.loadOrganization = async function (key){
                const organization = await organizationService.get(key);
                $scope.organizationName = _.get(organization, 'name');
                $scope.organizationLogo = _.get(organization, 'facility.logoURL');
                $scope.organizationId = _.get(organization, '_id');
                $scope[`organizationNameisDisabled`] = !!$scope.organizationName;
            }
            this.$onInit = async function () {
                console.log("PRN Activate Controller");
                const { organization_id, isMarketplace } = $location.$$search;
                const { user_id, token } = $stateParams;
                $scope.token = token;
                $scope.userId = user_id;
                $scope.pageLoading = true;
                $timeout(() => $loading.start('prnSignUp'));

                try {
                    const { email, firstName, lastName, phoneNumber, profession, affiliations = [], isMarketplace: marketplace, briefcase } = await ProfessionalService.get(user_id, { verificationToken: token });
                    $scope.affiliations = affiliations;
                    $scope.userLicense = briefcase && briefcase.licenses ? briefcase.licenses[0].licenseType : '';
                    $scope.userSpecialties = briefcase && briefcase.specialties ? briefcase.specialties.join(', ') : (briefcase?.licenses ? 'None': '');
                    const isMKP = isMarketplace === 'true' || marketplace;
                    $scope.showAffiliations = affiliations.length > 1 ||
                        (isMKP && affiliations.length) ||
                        (organization_id && _.get(affiliations, '[0].organization._id') !== organization_id);
                    const aff = [...affiliations];
                    if(organization_id){
                        aff.push({ organization: { _id: organization_id }})
                    }
                    const uniqueAffiliations = _.uniqBy(aff, 'organization._id')
                    if(uniqueAffiliations.length === 1){
                        if(organization_id){
                            await this.loadOrganization(organization_id);
                        } else {
                            const { organization } = uniqueAffiliations[0];
                            $scope.organizationName = _.get(organization, 'name');
                            $scope.organizationLogo = _.get(organization, 'facility.logoURL');
                            $scope.organizationId = _.get(organization, '_id');
                            $scope[`organizationNameisDisabled`] = !!$scope.organizationName;
                        }
                    }
                    if(organization_id && !affiliations.find(({ organization }) => organization._id === organization_id)){
                        const organization = await organizationService.get(organization_id);
                        affiliations.push({ organization });
                    }
                    if(isMKP){
                        $scope.affiliations.push({ organization: { name: 'Praos Health'}});
                    }
                    
                    $scope.user = { email, firstName, lastName, phoneNumber, profession, isMarketplace: isMarketplace === 'true', organizationId: $scope.organizationId };
                    Object.keys($scope.user).forEach((key) => $scope[`${key}isDisabled`] = !!$scope.user[key]);
                    $scope.pageLoading = false;
                    $loading.finish('prnSignUp');
                    $scope.$apply();
                } catch (e){
                    toastr.error(e.message);
                }
            }

            // =============to submit form=============
            $scope.submit = async function (valid) {
                if(!valid){ return; }

                const { organization_id, recruiter_id, isMarketplace } = $location.$$search;
                const { password, phoneNumber, profession } = $scope.user;
                const options = { token: $scope.token, password, profession };
                if (organization_id) {
                    options.organizationId = organization_id;
                }

                if (isMarketplace == 'true') {
                    options.isMarketplace = true;
                }

                if (recruiter_id) {
                    options.recruiterId = recruiter_id;
                }
                
                if(phoneNumber){
                    options.phoneNumber = phoneNumber.replace(/\-/g, '');
                }

                try {
                    const newToken = await ProfessionalService.verify($scope.userId, options);
                    $scope.success = 'Your account successfully verified';
                    authApi.setToken(newToken);
                    await sessionService.updateProfessional();
                    await sessionService.updateNotifications();
                    $state.go('splash');
                }
                catch (e) {
                    toastr.error(e.message);
                }
            }

            /* close Dialogbox function */
            $scope.closeBanner = function () {
                $scope.bannerClose = true;
            }
    }]);